import { DialogTitle } from "@headlessui/react"
import { ReactNode } from "react"

type Props = { children: ReactNode }

const ModalTitle = ({ children }: Props) => (
  <DialogTitle as="h3" className="text-lg font-medium leading-6">
    {children}
  </DialogTitle>
)

export default ModalTitle
